import styled, { createGlobalStyle } from "styled-components";

import {
  Header,
} from "layout";
import {Cabinet, Login} from "pages";

import { Route, Switch, useHistory } from "react-router";
import React, { Suspense, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  setClientWidth, setLoader } from "reducers";
import {
  LOGIN_PATH,
  BASE_COURSES,
  BASE_COURSES_VIEW,
  BASE_COURSES_LESSON,
} from "constants/paths";
import { getUserInfoActionCreator } from "api/UserAPI";
import { push } from "connected-react-router";
import {
  getToken,
} from "utils";
import { getUserName } from "selectors/userInfo";
import moment from "moment";
import { BaseCourses } from "./pages/BaseCourses";
import { BaseCourseView } from "./pages/BaseCourses/BaseCoursesView";
import { BaseCourseVideo } from "./pages/BaseCourses/BaseCourseVideo";


moment.locale("ru");

const AppContainer = styled.div`
  display: flex;
  align-items: stretch;
`;


const App = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userName = useSelector(getUserName);

  const handleResizeWindow = useCallback(() => {
    dispatch(setClientWidth(window.innerWidth));
  }, [dispatch]);

  //resize window handler for adaptive design
  useEffect(() => {
    window.addEventListener("resize", handleResizeWindow);

    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, [handleResizeWindow]);


  useEffect(() => {
    if (!getToken()) {
      dispatch(push("/login"));
      dispatch(setLoader({ value: false }));
    }

    dispatch(getUserInfoActionCreator(history.push));
    // eslint-disable-next-line
  }, [dispatch, userName]);

  return (
    <AppContainer>
      <Switch>
        <Route
          exact
          path={LOGIN_PATH}
          component={() => {
            return <Login />;
          }}
        />
        <Route path="*">
          <ContentContainerBlock>
            <Header />
            <Suspense fallback={<div>Загрузка...</div>}>
              <Switch>
                <Route exact path={["/cabinet", "/"]}>
                  <Cabinet />
                </Route>
                <Route exact path={BASE_COURSES}>
                  <BaseCourses />
                </Route>
                <Route exact path={BASE_COURSES_VIEW}>
                  <BaseCourseView />
                </Route>
                <Route exact path={BASE_COURSES_LESSON}>
                  <BaseCourseVideo />
                </Route>
              </Switch>
            </Suspense>
          </ContentContainerBlock>
        </Route>
      </Switch>
    </AppContainer>
  );
};

export default App;

const ContentContainerBlock = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 100vh;
`;
